// AI Job Search has been merged into the main job search.
// This route redirects to /dashboard/search so any bookmarked or linked URLs still work.
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/dashboard/ai-search')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$locale/jobs', params })
  },
})
